import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Card, Container, Grid, Button } from "@mui/material";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import { motion } from "framer-motion";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import DefaultNavbar from "devComponents/Navbars/PublicNavbar";
import Feature from "./Feature";

const Index = () => {
  const location = useLocation();
  const project = location?.state?.project;

  const [imgSrc, setImgSrc] = useState("");

  useEffect(() => {
    const fetchImage = async () => {
      try {
        const storage = getStorage();
        const imageRef = ref(storage, `PastProjects/${project.id}/CoverImage`);
        const url = await getDownloadURL(imageRef);
        setImgSrc(url);
      } catch (error) {
        console.error("Error fetching image:", error);
      }
    };

    if (project?.id) fetchImage();
  }, [project]);

  if (!project) {
    return (
      <MKBox
        minHeight="100vh"
        display="flex"
        justifyContent="center"
        alignItems="center"
        color="white"
        sx={{
          backgroundColor: "#0f172a",
        }}
      >
        <MKTypography variant="h5">No project data available</MKTypography>
      </MKBox>
    );
  }

  return (
    <MKBox
      sx={{
        backgroundColor: "#0f172a", // Dark slate background
        background: "linear-gradient(to bottom right, #0f172a, #1e293b)",
        minHeight: "100vh",
        position: "relative",
        overflowX: "hidden",
      }}
    >
      <DefaultNavbar />

      {/* Hero Section */}
      <MKBox
        component={motion.div}
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        sx={{
          pt: 5,
          pb: 7,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          px: 2,
          position: "relative",
          zIndex: 1,
        }}
      >
        <MKTypography
          variant="h1"
          color="white"
          mb={2}
          sx={{
            fontWeight: "800",
            letterSpacing: "-1px",
            background: "white",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            fontSize: { xs: "2.5rem", md: "4rem" },
          }}
        >
          {project.title}
        </MKTypography>
        <MKTypography
            variant="body1"
            color="white"
            sx={{
              maxWidth: "700px",
              margin: "0 auto",
              opacity: 0.8,
              fontSize: { xs: "1rem", md: "1.25rem" },
              lineHeight: 1.8,
            }}
          >
            {project.description}
          </MKTypography>
      </MKBox>

      {/* Project Details Section */}
      <MKBox pb={10} sx={{ position: "relative", zIndex: 1 }}>
        <Container>
          {/* Features Header */}
          {/* <MKBox mb={6} textAlign="center">
            <MKTypography
              variant="h3"
              color="white"
              fontWeight="bold"
              mb={1}
            >
              Project Features
            </MKTypography>
            <MKTypography
              variant="body1"
              color="white"
              sx={{ opacity: 0.7, maxWidth: "600px", mx: "auto" }}
            >
              Explore the main highlights and features of this project.
            </MKTypography>
          </MKBox> */}

          {/* Features List */}
          <MKBox>
            {project.features?.map((feature, index) => (
              <Feature
                key={index}
                Project={project}
                Feature={feature}
                index={index}
              />
            ))}
          </MKBox>
        </Container>
      </MKBox>
    </MKBox>
  );
};

export default Index;
